export default function (section, mainCategory, categories) {
  const cookieStorage = {
    getItem(key) {
      let cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].split('=');
        if (key == cookie[0].trim()) {
          return decodeURIComponent(cookie[1]);
        }
      }
      return null;
    },
    setItem(key, value) {
      const now = new Date();
      let time = now.getTime();
      time += 3600 * 1000;
      now.setTime(time);
      document.cookie = key + '=' + encodeURIComponent(value) + '; expires=' + now.toUTCString() + '; path=/';
    }
  };

  return {
    categories: categories,
    articles: [],
    pagination: null,
    currentPage: 1,
    articleCategory: this.$persist([]).using(cookieStorage),
    year: '',
    orderBy: 'desc',
    loading: false,
    showFilters: false,
    init() {
      const categoriesIds = categories.flatMap(c => c.children.map(c => c.id));
      const containsAllIds = this.articleCategory.every(c => categoriesIds.includes(parseInt(c)));
      if (!containsAllIds) {
        this.articleCategory = [];
      }
      this.fetchArticles();
    },
    async fetchArticles() {
      const params = new URLSearchParams({
        section: section,
        mainCategory: mainCategory,
        articleCategory: this.articleCategory,
        year: this.year,
        orderBy: this.orderBy,
        page: this.currentPage
      });
      const url = `/${document.documentElement.lang}/articles.json?${params}`;
      this.loading = true;
      console.log(url);
      const response = await fetch(url);
      console.log(response);

      this.loading = false;
      const data = await response.json();
      console.log(data);
      this.articles = this.articles.concat(data.data);
      this.pagination = data.meta.pagination;
    },
    nextPage() {
      this.currentPage += 1;
      this.fetchArticles();
    },
    filterChange() {
      this.articles = [];
      this.currentPage = 1;
      this.fetchArticles();
    }
  };
}
